import { useMemberSignupRequestModal } from '../../../component/MemberSignupRequestModal';

export const useShowAnonymousLikeCountLimitAlert = () => {
  const param = useMemberSignupRequestModal();
  return {
    show: () =>
      param.show({
        title: '상품 5개 찜 완료!',
        description: '지금 가입하고\n더 많은 상품을 만나보세요',
      }),
  };
};
